import { render, staticRenderFns } from "./DDCelebrateShareComponent.vue?vue&type=template&id=70b4efd5&scoped=true"
import script from "./DDCelebrateShareComponent.vue?vue&type=script&lang=js"
export * from "./DDCelebrateShareComponent.vue?vue&type=script&lang=js"
import style0 from "./DDCelebrateShareComponent.vue?vue&type=style&index=0&id=70b4efd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4efd5",
  null
  
)

export default component.exports